import type { EdgeData } from "../StructureViewFlowDiagram.types";

/** Returns all edges of a node that are connected from the node (source) to other nodes */
export function getConnectedSourceEdgesOfNode(
  nodeId: string,
  edges: Array<EdgeData>
) {
  return edges.filter((edge) => edge.from.toString() === nodeId);
}
